// extracted by mini-css-extract-plugin
export var cardHeader = "_ey-0";
export var reorderHandle = "_ey-3";
export var titleArea = "_ey-1";
export var titleAreaWithHandle = "_ey-2";